import { render, staticRenderFns } from "./EnrollementStatusModal.vue?vue&type=template&id=c485754c&scoped=true"
import script from "./EnrollementStatusModal.vue?vue&type=script&lang=js"
export * from "./EnrollementStatusModal.vue?vue&type=script&lang=js"
import style0 from "./EnrollementStatusModal.vue?vue&type=style&index=0&id=c485754c&prod&scoped=true&lang=css"
import style1 from "./EnrollementStatusModal.vue?vue&type=style&index=1&id=c485754c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c485754c",
  null
  
)

export default component.exports